import { isObject, hasProp, toMediaQuery } from 'vessel/utils'

import Config from '../provider/config'

const screenSizes = Config.screens

export default function value2mq(value) {
  let query = value

  if (!isObject(query))
    query = { minWidth: query }

  Object.entries(query).forEach(([key, value]) => {
    if (hasProp(value, screenSizes)) {
      let queryValue = screenSizes[value]

      if (key == 'maxWidth')
        queryValue = `${parseInt(queryValue) - 1}px`

      query[key] = queryValue
    }
  })

  return toMediaQuery(query)
}
